import * as types from 'shared/components/NewNavbar/types';

import styles from './ExpandableMenuItem.module.scss';

export function ExpandableMenuItem({ children, title }: types.ExpandableMenuItem) {
  return (
    <>
      <div className={styles.expandableLink} data-expandable="true">
        <div className={styles.title}>{title}</div>
        {children && (
          <div className={styles.childrenWrapper}>
            <div className={styles.expandedContent}>{children}</div>
          </div>
        )}
      </div>
    </>
  );
}
